var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dashboard-block" }, [
    _c("h2", [
      _vm._v("Booked " + _vm._s(_vm._f("sentenceCase")(_vm.$starLabelPlural))),
    ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "list-items" },
      _vm._l(_vm.bookingTalents, function (user) {
        return _c("booking-talent-list-item", {
          key: user.id,
          attrs: { user: user, booking: _vm.booking },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }